module.exports = function () {
    $(document).ready(function (event) {


        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');

        $(document).on('click', 'input[id^="emailed-"]', function(e){

            var that = this;
            var guardianId = that.id.substring(8, that.id.length);
            var url = '/api/guardians/change-emailed-field';

            if (that.checked) { var newState = 1; } else { var newState = 2; }
            var data = {
                field: 'emailed',
                guardianId: guardianId,
                value: newState
            };
            var success = function (response) {
                //console.log('Success');
                }
            var error = function (response) {
                //console.log('Error');
            }

            AjaxController.prototype.send(url, data, success, error);
        });


        $(document).on('click', 'input[id^="phoned-"]', function(e){

            var that = this;
            var guardianId = that.id.substring(7, that.id.length);
            var url = '/api/guardians/change-phoned-field';

            if (that.checked) { var newState = 1; } else { var newState = 0; }
            var data = {
                field: 'phoned',
                guardianId: guardianId,
                value: newState
            };
            var success = function (response) {
             //   console.log('Success');
            }
            var error = function (response) {
            //    console.log('Error');
            }

            AjaxController.prototype.send(url, data, success, error);
        });


        $(document).on('click', 'input[id^="voicemail-"]', function(e){

            var that = this;
            var guardianId = that.id.substring(10, that.id.length);
            var url = '/api/guardians/change-voicemail-field';

            if (that.checked) { var newState = 1; } else { var newState = 0; }
            var data = {
                field: 'voicemail',
                guardianId: guardianId,
                value: newState
            };
            var success = function (response) {
            //    console.log('Success');
             }
            var error = function (response) {
            //    console.log('Error');
            }

            AjaxController.prototype.send(url, data, success, error);
        });


    });
}();
